import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { onboardingActions } from "stores/onboarding/onboardingActions";
import { commonActions } from "stores/common/commonActions";
import { getKycCrossProductProps } from "helper/kycDocumentUpload";
import { config } from "config";

const mapStateToProps = (state) => {
    return {
        currentStage: state.onboarding.currentStage,
        loginProfile: state.customer.loginProfile,
        pan: state.onboarding.pan,
        dateOfBirth: state.onboarding.dateOfBirth,
        aadharNumber: state.onboarding.aadharNumber,
        isPanUploaded: state.onboarding.isPanUploaded,
        isAadhaarFrontUploaded: state.onboarding.isAadhaarFrontUploaded,
        isAadhaarBackUploaded: state.onboarding.isAadhaarBackUploaded,
        panVerification: state.onboarding.panVerification,
        aadharFrontVerification: state.onboarding.aadharFrontVerification,
        aadharBackVerification: state.onboarding.aadharBackVerification,
        ...getKycCrossProductProps(state, config.productCodes.PORTFOLIO),
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getOnboardingDataAction: onboardingActions.getOnboardingData,
            updateOnboardingData: onboardingActions.updateOnboardingData,
            setToast: commonActions.setToast,
        },
        dispatch
    );

const CKYCStore = (Container) =>
    connect(mapStateToProps, mapDispatchToProps)(Container);
export default CKYCStore;
